import { createFileRoute, redirect } from '@tanstack/react-router';

/** @note 未実装のため組織図にリダイレクト */
export const Route = createFileRoute('/_staff/organization/_list/cost/')({
  beforeLoad: () => {
    throw redirect({ to: '/organization/chart' });
  },
});
